module.exports = __webpack_public_path__ + "static/img/left_arrow_h5.5112041.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hmStyle/left_arrow_h5.png
// module id = XSAR
// module chunks = 34